/**
 * Client-side mirror of `server/api/tests/catalog.php` for offline UI and routing.
 * Keep in sync when adding new Salifert endpoints.
 */
export const SALIFERT_TEST_DEFINITIONS = [
  {
    code: 'kh_alk',
    title: 'KH / Alkalinity',
    primaryUnit: 'dKH',
    pagePath: '/salifert-tests',
    implemented: true
  },
  { code: 'calcium', title: 'Calcium', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'magnesium', title: 'Magnesium', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'nitrate', title: 'Nitrate', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'nitrite', title: 'Nitrite', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'ammonia', title: 'Ammonia', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'phosphate', title: 'Phosphate', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'salinity', title: 'Salinity', primaryUnit: 'ppt', pagePath: '/salifert-tests', implemented: true },
  { code: 'ph', title: 'pH', primaryUnit: 'pH', pagePath: '/salifert-tests', implemented: true },
  { code: 'iodine', title: 'Iodine', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true },
  { code: 'copper', title: 'Copper', primaryUnit: 'ppm', pagePath: '/salifert-tests', implemented: true }
];
